import React, { useRef, useState, useEffect } from 'react';

import Process from '../Process';

import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className="cursor-pointer absolute" style={{ top: '50%', right: '-30px', transform: 'translateY(-50%)' }} onClick={onClick}>
      <img src="/images/icons/navbar-arrow.svg" alt="navbar-arrow" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className="cursor-pointer absolute -left-30" style={{ top: '50%', transform: 'translateY(-50%) scaleX(-1)' }} onClick={onClick}>
      <img src="/images/icons/navbar-arrow.svg" alt="navbar-arrow" />
    </div>
  );
}

export default function VideoReviewsSlider(props) {
  const settings = {
    infiniteLoop: true,
    speed: 400,
    slidesToShow: 3,
    autoplay: false,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: '15px',
        },
      },
    ],
    afterChange: function (a, b) {
      props.reviews?.forEach((el, i) => {
        document.getElementById('play_' + i).style.display = 'block';
        document.getElementById('pause_' + i).classList.remove('paused');
        toogleRef.current[i].pause();
      });
    },
  };
  let toogleRef = useRef([]);

  const toogleFun = (ind, play = true) => {
    props.reviews?.forEach((el, i) => {
      if (i != ind) {
        const divs = document.querySelectorAll('#play_' + i);
        [].forEach.call(divs, function (div) {
          // do whatever
          div.style.display = 'block';
        });
      }
      document.querySelectorAll('#pause_' + i).forEach(function (div) {
        div.classList.remove('paused');
      });
      toogleRef.current[i].pause();
    });
    if (play) {
      toogleRef.current[ind].play();
      document.querySelectorAll('#play_' + ind).forEach(function (div) {
        div.style.display = 'none';
      });
      document.querySelectorAll('#pause_' + ind).forEach(function (div) {
        div.classList.add('paused');
      });
      // document.getElementById('play_'+ind).style.display="none"

      document.getElementById('pause_' + ind).classList.add('paused');
    } else {
      toogleRef.current[ind].pause();
      document.querySelectorAll('#play_' + ind).forEach(function (div) {
        div.style.display = 'block';
      });
      document.querySelectorAll('#pause_' + ind).forEach(function (div) {
        div.classList.remove('paused');
      });
    }
  };

  const [playing, setPlaying] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const handleScroll = e => {
    if (
      document.getElementById('slider_reviews').offsetTop + document.getElementById('slider_reviews').clientHeight <= window.pageYOffset ||
      document.getElementById('slider_reviews').offsetTop - document.getElementById('slider_reviews').clientHeight >= window.pageYOffset
    ) {
      props.reviews?.forEach((el, i) => {
        document.querySelectorAll('#play_' + i).forEach(function (div) {
          div.style.display = 'block';
        });
        document.querySelectorAll('#pause_' + i).forEach(function (div) {
          div.classList.remove('paused');
        });
        document.getElementById('play_' + i).style.display = 'block';
        document.getElementById('pause_' + i).classList.remove('paused');
        toogleRef.current[i].pause();
      });
    }
  };
  const tooglePlayPause = (ind, play) => {
    if (window.innerWidth < 1024) toogleFun(ind, play);
  };
  return (
    <div id="slider_reviews">
      <Slider {...settings} className="process-slider relative z-10">
        {props.reviews?.map((review, index) => (
          <div className={`w-full for-hover pt-10 pb-10 ${index != 0 ? 'p-20 pl-0' : 'p-20 pl-0'}`} key={'video_reviews_slider' + index}>
            <style jsx global>{`
              .pause {
                display: none !important;
              }

              .for-hover:hover .paused.pause {
                display: block !important;
              }
              .slick-list:first-of-type,
              for-hover:first-of-type {
                padding-left: 0 !important;
              }
              .slick-slide {
                outline: none;
              }
              .slick-slide div {
                outline: none;
              }
              .slick-slide:focus,
              .slick-slide a {
                outline: none;
              }
              @media screen and (max-width: 1024px) {
                .for-hover:hover .paused.pause {
                  display: none !important;
                }
              }
            `}</style>
            <div className="relative">
              <video
                className="max-w-400 md:max-w-700"
                preload={'metadata'}
                onClick={() => tooglePlayPause(index, toogleRef.current[index].paused)}
                poster={review.thumbnail}
                webkit-playsinline={'true'}
                playsInline={true}
                width={'100%'}
                ref={element => toogleRef.current.push(element)}
              >
                <source src={review.video} type="video/mp4" />
              </video>
              <img
                onClick={() => toogleFun(index)}
                id={`play_${index}`}
                width={50}
                className="absolute play cursor-pointer top-show-more left-show-more"
                src="https://weprodigi.com/uploads/files/shares/thumbs/play-button.png"
              />
              <img
                onClick={() => toogleFun(index, false)}
                id={`pause_${index}`}
                width={50}
                className="absolute pause cursor-pointer top-show-more left-show-more"
                src="https://weprodigi.com/uploads/files/shares/thumbs/pause.png"
              />
            </div>

            <div className="flex justify-between start mt-5">
              <div>
                <p className="text-16 mt-10 font-bolder leading-24 uppercase text-purple">{review.custommerName}</p>
                <p className="mt-5 pb-20 flex  text-black leading-24 text-12 md:text-14 items-center ">
                  {review.position} <img className="ml-15" width={props.width < 768 ? 15 : 23} height={15} src={review.flag} alt="review" />{' '}
                </p>
                {review.case && (
                  <a href={review.case} className="mt-25 bg-green hover:bg-purple text-white py-10 px-20 rounded-5">
                    See Video
                  </a>
                )}
              </div>
              <div className="text-right">
                <img src={review.logo} width={props.from == 'ppc' ? 51 : 'auto'} className={props.from == 'ppc' ? '' : 'mt-10'} alt="review" />
              </div>
            </div>
            <div className={''}></div>
          </div>
        ))}
      </Slider>
    </div>
  );
}
